import * as Yup from "yup";
import dayjs from "dayjs";

export const adjustmentTypes = {
    increase: {
        id: "increase",
    },
    decrease: {
        id: "decrease",
    }
}

export const validateRowSchema = Yup.object().shape({
    itemId: Yup
        .string()
        .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    qty: Yup
        .number()
        .typeError("Number Only")
        .required("Required"),
        // .test(
        //     "is-positive",
        //     "Please enter a positive number",
        //     (value) => value >= 0 && 1 / value !== -Infinity),
    adjustmentType: Yup
        .mixed()
        .oneOf(Object.keys(adjustmentTypes).map(i => adjustmentTypes[i].id))
        .required('Required'),
})

export const validationSchema = Yup.object({
    // description: yup
    //     .string()
    //     .required('Description is required'), 
    documentDate: Yup
        // .string()
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    locationId: Yup
        .string()
        .required("Required"),
    
    rows: Yup.array().of(validateRowSchema)
})

export const initialRowValues = {
    docItemId: 0,
    itemId: "",
    name: "",
    code: "",
    decription: "",
    qty: 0,
    uonName: "",
    uomId: "",
    price: "",
    scanType: false,
    adjustmentType: adjustmentTypes.increase.id
}

export const initialValues = {
    documentDate: dayjs(),
    rows: [initialRowValues],
    totalqty: "0",
    locationId: "",
    locationName: "",
}

// export const getValidationVerifySchema = ({ maxQty = '', enableTrackBatch = false }) => {

//     const docItemId = Yup.object({
//         docItemId: Yup
//             .string()
//             .required("Doc Item is required"),
//     })

//     const rackId = Yup.object({
//         rackId: Yup
//             .string()
//             .required("Rack is required"),
//     })

//     const slotId = Yup.object({
//         slotId: Yup
//             .string()
//             .required("Slot is required"),
//     })

//     const barcode = Yup.object({
//         barcode: Yup
//             .string()
//             .required("Barcode is required"),
//     })

//     let verifyInQty;

//     if(maxQty){
//         verifyInQty = Yup.object({
//             verifyInQty: Yup
//                 .number()
//                 .typeError("Qty only number")
//                 // .positive("Qty must more than zero")
//                 .max(maxQty, `Max only ${maxQty}`)
//                 .required("Qty is required"),
//         })

//     }else{
//         verifyInQty = Yup.object({
//             verifyInQty: Yup
//                 .number()
//                 .typeError("Qty only number")
//                 .positive("Qty must more than zero")
//                 .required("Qty is required"),
//         })
//     }

//     const expiryDate = Yup.object({
//         expiryDate: Yup
//             .date("Invalid")
//             .required("Required")
//             .typeError("Invalid"),
//     })

//     const customBatchNo = Yup.object({
//         customBatchNo: Yup
//             .string()
//             .required("Batch Number is required"),
//     })

//     let schema

//     if(enableTrackBatch){
//         schema = docItemId.concat(rackId).concat(slotId).concat(barcode).concat(verifyInQty).concat(expiryDate).concat(customBatchNo)
//     }else{
//         schema = docItemId.concat(rackId).concat(slotId).concat(barcode).concat(verifyInQty)
//     }

//     return schema
// }

// export const initialVerifyQtyValues = {
//     docItemId: "",
//     itemName: "",
//     rackId: "",
//     slotId: "",
//     verifyInQty: "",
//     barcode: "",
//     customBatchNo: "",
//     expiryDate: dayjs()
// }
